import { SearchIcon } from "@heroicons/react/solid";
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import bgOverlay from "../../../assets/bgOverlay.png";
import dummyMap from "../../../assets/dummyMap.png";
import facebookIcon from "../../../assets/facebook.svg";
import playIcon from "../../../assets/googlePlayIcon.png";
import instagramIcon from "../../../assets/instagram.svg";
import orderTrackingIcon from "../../../assets/order_tracking_icon.png";
import refundIcon from "../../../assets/refund_icon.png";
import returnProductIcon from "../../../assets/return_product.png";
import twitterIcon from "../../../assets/twitter.svg";
import youtubeIcon from "../../../assets/youtube.svg";
import "../Signup/Signup.css";

function Map() {
  const center = useMemo(() => ({ lat: 44, lng: -80 }), []);

  return (
    <GoogleMap zoom={10} center={center} mapContainerClassName="map-container">
      <Marker position={center} />
    </GoogleMap>
  );
}

export const ContactUs = () => {
  const baseURL = process.env.REACT_APP_BASE_URL;
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyBSjm0Ux_6OYMBxXoZZcGf6Td1Tb9TIMW0",
  });

  const {
    register,
    handleSubmit,
    reset,
    formState: { inputErrors },
  } = useForm();

  const onSubmit = (data) => {
    setContactData(data);
  };
  const [contactData, setContactData] = useState();

  useEffect(() => {
    // console.log(contactData)
    if (contactData) {
      axios
        .post(baseURL + "user-service/api/v1/users/contact_us/", {
          name: contactData.name,
          email: contactData.email,
          message: contactData.message,
        })
        .then(function (response) {
          // console.log(response)
          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          reset();
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    }
  }, [contactData]);

  return (
    <div className="container mx-auto px-3 sm:px-0">
      <div className=" pt-2">
        <h1 className="text-gray-700 text-xl md:text-2xl font-semibold">
          Contact Us
        </h1>
        <p className=" text-xs sm:text-sm mt-1">
          Welcome to Buduy. How can we help you today?
        </p>
      </div>
      <div
        className="bg-[#3076CE] mt-6 py-12 sm:py-[6rem]"
        style={{ backgroundImage: `url(${bgOverlay})` }}
      >
        <div className="font-bold text-white text-center tracking-wide text-sm sm:text-lg">
          For Instant Query You Can Search Our Help Library
        </div>
        <label className="relative block px-6 sm:px-0 mt-5 w-full md:w-1/2 mx-auto">
          <span className="sr-only">Search</span>
          <span className="absolute inset-y-0 right-7 sm:right-2 flex items-center pr-2">
            <SearchIcon className=" h-7 sm:h-9 w-6 fill-slate-300" />
          </span>
          <input
            className="placeholder:text-slate-400 block bg-white h-11 w-full border border-slate-300 rounded-md py-2 pl-3 sm:pl-5 pr-12 shadow-sm focus:outline-none focus:border-sky-500 focus:ring-sky-500 focus:ring-1 sm:text-sm"
            placeholder="Type your query, eg: Refund"
            type="text"
            name="search"
          />
        </label>
      </div>
      <div className=" mt-9">
        <h4 className=" sm:text-lg font-semibold">
          Browse FAQs Under These Category
        </h4>
        <div className="flex justify-start gap-4 items-center flex-wrap mt-5">
          <Link to="#" className="md:w-1/6">
            <div className="bg-[#F3F9FF] rounded-md p-3 sm:p-6 hover:bg-[#3076CE] group">
              <img
                src={orderTrackingIcon}
                className="h-8 sm:h-16 w-8 sm:w-16 mx-auto group-hover:fill-white"
                alt="Order Tracking Icon"
              />
              <p className="text-xs sm:text-base text-black-400 text-center mt-2 group-hover:text-white">
                Order Tracking
              </p>
            </div>
          </Link>
          <Link to="#" className="md:w-1/6">
            <div className="bg-[#F3F9FF] rounded-md p-3 sm:p-6 hover:bg-[#3076CE] group">
              <img
                src={refundIcon}
                className="h-8 sm:h-16 w-8 sm:w-16 mx-auto group-hover:fill-white"
                alt="Refund Icon"
              />
              <p className="text-xs sm:text-base text-black-400 text-center group-hover:text-white mt-2">
                Refund
              </p>
            </div>
          </Link>
          <Link to="#" className="md:w-1/6">
            <div className="bg-[#F3F9FF] rounded-md p-3 sm:p-6 hover:bg-[#3076CE] group">
              <img
                src={returnProductIcon}
                className="h-8 sm:h-16 w-8 sm:w-16 mx-auto group-hover:fill-white"
                alt="Order Tracking Icon"
              />
              <p className="text-xs sm:text-base text-black-400 text-center group-hover:text-white mt-2">
                Return a Product
              </p>
            </div>
          </Link>
        </div>
      </div>
      <div className=" mt-12">
        <h4 className="text-2xl sm:text-3xl text-gray-700 font-semibold mb-3">
          Get In Touch
        </h4>
        <div className="flex flex-col-reverse sm:flex-row justify-between gap-y-3  w-full sm:space-x-3">
          <div className="w-full md:w-1/2">
            {/* {isLoaded ? <Map /> : "Loading"} */}
            <img
              src={dummyMap}
              alt="dummyMap"
              className=" h-60 sm:h-96 w-full sm:w-full object-cover relative sm:-left-4"
            />
          </div>

          <div className="w-full md:w-1/2">
            <form onSubmit={handleSubmit(onSubmit)}>
              {/* name */}
              <div className="form-group cmb-10">
                <label className="pure-material-textfield-outlined">
                  <input
                    type="text"
                    placeholder=" "
                    {...register("name", { required: true })}
                  />

                  <span className="text-gray-700 font-medium">Your Name</span>
                </label>
              </div>
              {/* email */}
              <div className="form-group cmb-10">
                <label className="pure-material-textfield-outlined">
                  <input
                    type="email"
                    placeholder=" "
                    {...register("email", { required: true })}
                  />

                  <span className="text-gray-700 font-medium">
                    Your Email Address
                  </span>
                </label>
              </div>
              {/* phone */}
              {/* <div className='form-group cmb-10'>
								<label className='pure-material-textfield-outlined'>
									<input type='text' placeholder=' ' {...register("phone", {required: true})} />

									<span className='text-gray-700 font-medium'>Your Phone Number</span>
								</label>
							</div> */}
              {/* message */}
              <div className="form-group cmb-10">
                <label className="pure-material-textfield-outlined">
                  <textarea
                    type="text"
                    rows="7"
                    cols="5"
                    placeholder=" "
                    {...register("message", { required: true })}
                  />

                  <span className="text-gray-700 font-medium">
                    Your Message
                  </span>
                </label>
              </div>

              <input
                type="submit"
                value="Send Message"
                className=" text-sm sm:text-base px-6 sm:px-8 py-2 sm:py-3 cursor-pointer bg-gradient-to-r from-[#2995FC]  to-[#3076CE] text-white rounded-md mt-0 sm:mt-6"
              />
            </form>
          </div>
        </div>
      </div>
      <div className="my-3 sm:my-10 py-5 sm:py-10 bg-[#F3F9FF] rounded-[10px]">
        <div className=" grid grid-cols-2 sm:flex justify-center items-center gap-4 w-full">
          <div className="w-full md:w-1/4 flex justify-center items-start">
            <div>
              <p className="text-xs sm:text-sm font-bold">Email Us at</p>
              <p className="text-base sm:text-2xl font-bold text-[#3076CE] mt-2">
                info@byduy.uk
              </p>
              <p className="text-xs sm:text-sm font-light tracking-wide mt-2">
                for any kind of assistance
              </p>
            </div>
          </div>
          <div className="w-full md:w-1/4 flex justify-center items-start">
            <div>
              <p className="text-xs sm:text-sm font-bold">Call Us on</p>
              <p className="text-base sm:text-2xl font-bold text-[#3076CE] mt-2">
                002-555-5654
              </p>
              <p className="text-xs sm:text-sm  font-light tracking-wide mt-2">
                for instant support
              </p>
            </div>
          </div>
          <div className="w-full md:w-1/4 flex justify-start items-start">
            <div>
              <p className="text-xs sm:text-sm font-bold">Follow Us</p>
              <div className="flex items-center space-x-3 mt-2">
                <Link to="#">
                  <img src={facebookIcon} className="h-6" alt="Facebook Icon" />
                </Link>
                <Link to="#">
                  <img src={twitterIcon} className="h-6" alt="Twitter Icon" />
                </Link>
                <Link to="#">
                  <img
                    src={instagramIcon}
                    className="h-7"
                    alt="Instagram Icon"
                  />
                </Link>
                <Link to="#">
                  <img src={youtubeIcon} className="h-8" alt="Youtube Icon" />
                </Link>
              </div>
            </div>
          </div>
          <div className="w-full md:w-1/4 flex justify-center items-start">
            <div>
              <p className="text-xs sm:text-sm font-bold">Download Our App</p>
              <a href="#" className="block mt-2">
                <img
                  src={playIcon}
                  alt=""
                  className="h-12 sm:h-[4rem] w-auto"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};
